const state = () => ({
    visible: false,
    errorMessage: "Ein Fehler ist aufgetreten."
})

const mutations = {
    setMessage (state, message) {
        state.errorMessage = message
    },
    resetMessage (state) {
        state.errorMessage = "Ein Fehler ist aufgetreten."
    },
    setVisibility(state, visible) {
        state.visible = visible
    }
}

export default {namespaced: true, state, mutations}